export default {
  ACTIVITIES: 'Activities',
  HIGH_RISK_STUDENT_MEDICAL_CONDITIONS: 'High-Risk Student Medical Conditions'
};
